import React from "react";
import { PortForm } from "./Forms/PortForm";
import { useCreatePortMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreatePort = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
      code: "",
    },
    mode: "onChange",
  });

  const { mutate: createPort, isPending } = useCreatePortMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createPort(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_PORT")}  />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <PortForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_PORT")}
              </>
            ) : (
              t("CREATE_PORT")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};

